import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolRobloxBridgeStatus } from '../../../services/patrol-roblox-api.service';
import { PatrolRobloxCockpitService } from '../../../services/patrol-roblox-cockpit.service';

const I18N = 'app.patrol.roblox.cockpit';

@Component({
  selector: 'app-patrol-roblox-experience-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './patrol-roblox-experience-switcher.component.html',
  styleUrl: './patrol-roblox-experience-switcher.component.scss',
})
export class PatrolRobloxExperienceSwitcherComponent {
  #cockpit = inject(PatrolRobloxCockpitService);

  readonly i18n = I18N;

  readonly experiences = this.#cockpit.experiences;
  readonly selectedRegistryId = this.#cockpit.selectedRegistryId;
  readonly isLoading = this.#cockpit.isLoadingExperiences;
  readonly isAdding = this.#cockpit.isAddingExperience;
  readonly errorKey = this.#cockpit.experiencesError;

  readonly showCreateForm = signal(false);
  readonly newDisplayName = signal('');
  readonly newUniverseId = signal('');
  readonly createErrorKey = signal<string | null>(null);

  selectExperience(registryId: string): void {
    this.#cockpit.selectExperience(registryId);
  }

  refreshExperiences(): void {
    void this.#cockpit.loadExperiences();
  }

  bridgeStatusLabelKey(
    status: PatrolRobloxBridgeStatus | null | undefined,
  ): string {
    return this.#cockpit.bridgeStatusLabelKey(status);
  }

  toggleCreateForm(): void {
    this.showCreateForm.update((open) => !open);
    if (!this.showCreateForm()) {
      this.newDisplayName.set('');
      this.newUniverseId.set('');
      this.createErrorKey.set(null);
    }
  }

  async submitCreateForm(): Promise<void> {
    const displayName = this.newDisplayName().trim();
    const universeId = this.newUniverseId().trim();
    if (!displayName || !universeId || !/^\d+$/.test(universeId)) {
      this.createErrorKey.set('invalid_universe');
      return;
    }

    this.createErrorKey.set(null);
    const created = await this.#cockpit.addExperience(displayName, universeId);
    if (created) {
      this.newDisplayName.set('');
      this.newUniverseId.set('');
      this.showCreateForm.set(false);
      return;
    }
    this.createErrorKey.set('create_failed');
  }
}
